import { CSSProperties, FC } from 'react';
import styled from 'styled-components';
import { COLOURS } from '@belong/themes';
import { IconSize } from '@belong/types';
import { Icon, ICON_NAMES } from '../../../Icon';

interface IAccordionPlusMinusProps {
  isOpen: boolean;
  size?: IconSize;
  style?: CSSProperties;
}

const IconWrapper = styled.span`
  flex-shrink: 0;
  color: ${({ theme }) => COLOURS[theme.accordion.iconButtonColor]};
`;

export const AccordionPlusMinus: FC<IAccordionPlusMinusProps> = ({ isOpen, size = 'small', style }) => (
  <IconWrapper style={style}>
    <Icon name={isOpen ? ICON_NAMES.Remove : ICON_NAMES.Plus} size={size} />
  </IconWrapper>
);

AccordionPlusMinus.displayName = 'AccordionPlusMinus';
